'use strict';

import {Glide, Controls, Swipe, Breakpoints, Images } from './components/carousel'
let isDesktop = require('./utilities/clientSideUtil').isDesktop;
let isMobile = require('./utilities/clientSideUtil').isMobile;
var scrollAnimate = require('./components/scrollAnimate');
let sliderLimit = $('.content-blocks').data('slide-limit') - 1;
let desktopPerView = 5;
let ipadPerView = 1;
let mobilePerView = 1;
let colValue = $('.content-blocks').hasClass('layout--type-3') ? 4 : 3;

/**
 * Creates carousel bullet items
 * @param {jQuery} $parentEl container element
 */
function createControls($parentEl) {
    const $carouselItems = $($parentEl).find('.glide__slide').not('.glide__slide--clone');
    let $carouselBullets = $($parentEl).find('[data-glide-el="controls[nav]"]');
    $carouselItems.each(function (index) {
        var $newIndiator = $(`<button class="glide__bullet" data-glide-dir="=${index}" aria-label="Go to Slide ${index+1}"></button>`);
        $carouselBullets.append($newIndiator);
    });
    $carouselBullets.removeClass('d-none');
}

/**
 * updates the current bullet state 
 * @param {jQuery} $carouselElement container element
 */
function updateBulletState($carouselElement) {
    var $bullets = $carouselElement.find('.glide__bullet');
    $bullets.removeAttr('aria-current');
    $bullets.filter('.glide__bullet--active').attr('aria-current', 'true');
}

/**
 * updates the current slide 
 * @param {jQuery} $carousel container element
 */
function updateSlideAccessibility($carousel) {
    var $slides = $carousel.find('.glide__slide');
    var total = $slides.length;

    $slides.each(function (index) {
        var $slide = $(this);
        var isActive = $slide.hasClass('glide__slide--active');

        $slide.attr({
            role: 'group',
            'aria-roledescription': 'slide',
            'aria-label': (index + 1) + ' of ' + total
        });

        $slide.toggleClass('is-accessible-active', isActive);
    });
}

/**
 * Initialize carousel
 * @param {jQuery} $containerEl the wrapper element
 */
function initCarouselLayout($containerEl) {
    const $carousel = $($containerEl);
    const $carouselItems = $($carousel).find('.glide__slide').not('.glide__slide--clone');
    const $controls = $($carousel).find('[data-glide-el="controls"]');
    const $bullets = $($carousel).find('.glide__bullets');
    const $controlsConatiner = $($carousel).find('.glide__controls');
    const totalSlides = $carouselItems.length;
    const carouselStyle = $($carousel).find('.glide__track').data('carousel-style');
    const carouselPeek = $($carousel).find('.glide__track').data('carousel-peek');

    let glide;
    const defaults = {
        type: carouselStyle,
        perView: desktopPerView,
        rewind: true,
        bound: true,
        gap: 24,
        peek: {
            before: carouselPeek ? 130 : 0,
            after: carouselPeek ? 130 : 0
        },
        breakpoints: {
            1439: {
                rewind: true,
                gap: 24,
                perView: ipadPerView,
                bound: false,
                peek: {
                    before: 0,
                    after: 0
                },
            },
            767: {
                rewind: true,
                gap: 16,
                perView: mobilePerView,
                bound: false,
                peek: {
                    before: 0,
                    after: 0
                },
            }
        }
    };

    const handleUpdateEvent = () => {
        if (!glide) { return; }
        const { perView } = glide.settings;
        if (totalSlides <= perView) {
            $controlsConatiner.removeClass('d-flex').addClass('d-none');
            $controls.addClass('d-none');
            $bullets.removeClass('d-flex').addClass('d-none');
        } else {
            $controlsConatiner.removeClass('d-none').addClass('d-flex');
            $controls.removeClass('d-none');
            $bullets.removeClass('d-none').addClass('d-flex');
        }
    }

    glide = new Glide($carousel.get(0), defaults)
        .on('build.before', handleUpdateEvent)
        .mount({
            Controls,
            Breakpoints,
            Swipe,
            Images
        });
    handleUpdateEvent();

    setTimeout(function () {
        updateBulletState($carousel);
        updateSlideAccessibility($carousel)
    },100);
}

/**
 * Removing unslider class to align the layout
 * @param {jQuery} $parentEl container element
 */
function createUnsliderLayout($parentEl) {
    $($parentEl).addClass('layout-glide-section');
    $($parentEl).removeClass('glide mbb-glide-carousel');
    $($parentEl).find('.track-section').removeClass('glide__track');
    $($parentEl).find('.sliders-container').removeClass('glide__slides').addClass('row justify-content-center');
    $($parentEl).find('.glide__controls').addClass('d-none').removeClass('d-flex');
}

/**
 * Delete carousel based on different Up's
 * @param {jQuery} $parentEl container element
 */
function detachCarousel($parentEl) {
    const $sliderContainer = $($parentEl).find('.js-remove-slide');
    let $ctaContainer = $($parentEl).find('.content-blocks-buttons-js');
    $sliderContainer.each(function (index) {
        if (index <= sliderLimit) {
            $($sliderContainer[index]).removeClass('d-none');
        } else {
            $($sliderContainer[index]).detach();
        }

    });
    
    if (sliderLimit > 6 && $($parentEl).hasClass('tile-style-Stacking')) {
        $ctaContainer.find('.see-more-cta-js').removeClass('d-none');
        $($parentEl).find('.js-remove-slide:nth-child(n+7)').addClass('d-none d-lg-block');
    }
}

$(document).ready(function () {
    $('.content-blocks').each(function(i) {
        var headlineText = $(this).find('.mbb-header_header').text();
        if (headlineText) {
            $(this).find('.js-content-blocks-carousel').attr('aria-label', headlineText);
        }
        const slideLimit = $(this).data('slide-limit');
        sliderLimit = slideLimit - 1;
        $(this).find('.js-content-blocks-carousel').attr("id", "js-content-blocks-carousel-" + i);
        
        if ($(this).hasClass('layout--type-3') || $(this).hasClass('layout--type-4') || $(this).hasClass('layout--type-5') || $(this).hasClass('layout--type-4-up')) {
            if ($(this).hasClass('layout--type-3') && isDesktop()) {
                sliderLimit = 2;
                detachCarousel(this);
                createUnsliderLayout($(this).find('.js-content-blocks-carousel'));
                $(this).find('.js-content-blocks-carousel').find('.glide__slide').addClass('col-'+ colValue +'');
            } else if ($(this).hasClass('layout--type-3') && !isDesktop()) {
                sliderLimit = 2;
                detachCarousel(this);
                if ($(this).hasClass('mobile-stacked') && isMobile()) {
                    $(this).find('.js-content-blocks-carousel').find('.glide__slide').removeClass('col-4');
                    $(this).find('.js-content-blocks-carousel').find('.glide__controls').addClass('d-none').removeClass('d-flex');
                } else if ($(this).hasClass('tile-style-Stacking') && !isDesktop()) {
                    $(this).find('.js-content-blocks-carousel').find('.glide__slide').removeClass('col-4');
                    $(this).find('.js-content-blocks-carousel').find('.glide__controls').addClass('d-none').removeClass('d-flex');
                } else {
                    createControls('#js-content-blocks-carousel-' + i);
                    initCarouselLayout('#js-content-blocks-carousel-' + i);
                }
            } else if ($(this).hasClass('layout--type-4-up') || $(this).hasClass('layout--type-4')) {
                if (!$(this).hasClass('tile-style-Stacking')) {
                    detachCarousel(this);
                    desktopPerView = 4;
                    ipadPerView = 1;
                    mobilePerView = 1;
                    createControls('#js-content-blocks-carousel-' + i);
                    initCarouselLayout('#js-content-blocks-carousel-' + i);
                } else if ($(this).hasClass('tile-style-Stacking')) {
                    if (isDesktop()) {
                        detachCarousel(this);
                        createUnsliderLayout($(this).find('.js-content-blocks-carousel'));
                        $(this).find('.js-content-blocks-carousel').find('.glide__slide').addClass('col-'+ colValue +'');
                        $(this).find('.sliders-container').removeClass('justify-content-center').addClass('justify-content-start');
                    } else {
                        detachCarousel(this);
                        $(this).find('.js-content-blocks-carousel').find('.glide__slide').removeClass('col-4');
                        $(this).find('.js-content-blocks-carousel').find('.glide__controls').addClass('d-none').removeClass('d-flex');
                    }
                    
                }
            } else if ($(this).hasClass('tile-style-Stacking') && $(this).hasClass('layout--type-5')) {
                if (isDesktop()) {
                    detachCarousel(this);
                    createUnsliderLayout($(this).find('.js-content-blocks-carousel'));
                    $(this).find('.js-content-blocks-carousel').find('.glide__slide').addClass('col-'+ colValue +'');
                    $(this).find('.sliders-container').removeClass('justify-content-center').addClass('justify-content-start');
                } else {
                    detachCarousel(this);
                    $(this).find('.js-content-blocks-carousel').find('.glide__slide').removeClass('col-4');
                    $(this).find('.js-content-blocks-carousel').find('.glide__controls').addClass('d-none').removeClass('d-flex');
                }
            } else {
                detachCarousel(this);
                ipadPerView = 1;
                mobilePerView = 1;
                createControls('#js-content-blocks-carousel-' + i);
                initCarouselLayout('#js-content-blocks-carousel-' + i);
            }
        } else {
            detachCarousel(this);
            createUnsliderLayout($(this).find('.js-content-blocks-carousel'));
            $(this).find('.js-content-blocks-carousel').find('.glide__slide').addClass('col-'+ colValue +'');
        }
    });

    $(document).on('click', '.content-blocks-cta-js', function (e) {
        if ($(e.target).hasClass('see-more-cta-js')) {
            $(this).parents('.content-blocks').find('.js-remove-slide').removeClass('d-none');
            $(this).addClass('d-none');
            $(this).siblings('.see-less-cta-js').removeClass('d-none');
        } else {
            $(this).parents('.content-blocks').find('.js-remove-slide:nth-child(n+7)').addClass('d-none');
            $(this).addClass('d-none');
            $(this).siblings('.see-more-cta-js').removeClass('d-none');
            scrollAnimate($(this).siblings('.see-more-cta-js'));
        }
    });

    $(document).on('click', '.glide__arrow--right', function () {
        var $nextButton = $(this);

        setTimeout(function () {
            $nextButton.closest('.type-carousel').siblings('.glide__track').find('.glide__slide--active').find('.editorial-story-card__body a').focus();
        }, 1100);
    });

    $(document).on('click', '.js-content-blocks-carousel .glide__arrow, .js-content-blocks-carousel .glide__bullet', function () {
        var $element = $(this);
        setTimeout(function () {
            var $currentGlideElement = $element.parents('.glide__bullets').find('.glide__bullet');
            $currentGlideElement.removeAttr('aria-current');
            $currentGlideElement.filter('.glide__bullet--active').attr('aria-current', 'true');
        },1000);
    });
});

